import { createLazyApolloComponent } from 'owa-apollo-component';
import { LazyMailRibbonModule } from './lazyFunctions';
import CommandRibbonPlaceholder from 'owa-command-ribbon/lib/components/CommandRibbonPlaceholder';

export const LazyMailRibbon = createLazyApolloComponent(
    LazyMailRibbonModule,
    m => m.MailRibbon,
    CommandRibbonPlaceholder
);
